import { createReducer, on } from '@ngrx/store';
import { AccessControlListApiActions } from './room-acl.actions';
import { adapter, initialState } from './room-acl.state';

export const roomAclReducer = createReducer(
  initialState,
  on(AccessControlListApiActions.roomAclLoaded, (state, { roomAcl }) => adapter.addOne(roomAcl, state)),
  on(AccessControlListApiActions.roomAclMemberPut, (state, { aclMember }) =>
    adapter.updateOne(
      {
        id: aclMember.resourceId || '', // empty means all rooms,
        changes: {
          users: state.entities[aclMember.resourceId || ''].users.map((x) =>
            x.member === aclMember.member ? aclMember : x
          ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.roomAclGroupPut, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId || '',
        changes: {
          groups: state.entities[aclGroup.resourceId || ''].groups.map((x) =>
            x.groupId === aclGroup.groupId ? aclGroup : x
          ),
        },
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectRoomAclIds = selectIds;
export const selectRoomAcls = selectEntities;
export const selectAllRoomAcls = selectAll;
